export const firebaseConfig = {
  apiKey: "AIzaSyDH73lA2Y1Po1xqiKeuHLXaSXFSkLFJMho",
  authDomain: "pelvic-plan.firebaseapp.com",
  projectId: "pelvic-plan",
  storageBucket: "pelvic-plan.appspot.com",
  messagingSenderId: "756165069718",
  appId: "1:756165069718:web:4bee6737d79247d3032bb7",
  measurementId: "G-6G49BL2GTF",
};
